export default {"src":"/_next/static/image/public/assets/feature-images/en/sidebar.00a27232c91929bd3705f05152088344.svg","height":395,"width":320};